export default ({ smartCrossLinks }) => {
  return smartCrossLinks?.globalVariables?.br_iuid || "";
};
